import React from "react"

export default function DownloadPetModal() {
  return (
    <div id="downloadPetModal" className="modal modal-fixed-footer rf_modal ">
      <div className="modal-content">
        <div className="center">
          <img
            alt="animation about downloading your dog"
            src="http://haroldl.com/images/Download-Anim.png"
            className="rf_modal-anim center"
          />
        </div>
        <h4>Download</h4>
        <p>Your dog’s image is being downloaded to your device.</p>
      </div>
      <div className="modal-footer">
        <a href="#!" className="modal-close waves-effect waves-green btn-flat">
          OK
        </a>
      </div>
    </div>
  )
}
